import { signIn } from 'next-auth/react'

import { useCompany } from '@/hooks/useCompany'

export function useSignIn() {
  const company = useCompany()

  const signInWithCompany = () => {
    if (!company) {
      console.error('Company not found')
      return
    }

    signIn(
      'connect',
      undefined,
      company?.displayId ? { company: company.displayId } : undefined
    )
  }
  return { signIn: signInWithCompany }
}
